/// <amd-module name="Tfs/ReduxCommon/Modules/Teams/TeamSaga" />
import { effects, SagaIterator } from "redux-saga";
import { ITeam } from "Tfs/ReduxCommon/Contracts/Team";
import { TeamActionsCreator, TeamActionTypes } from "Tfs/ReduxCommon/Modules/Teams/TeamActions";
import { getTeams } from "Tfs/ReduxCommon/Modules/Teams/TeamSelectors";
import { TeamSource } from "Tfs/ReduxCommon/Modules/Teams/TeamSource";
import { IVssPageContext } from "VSS/Platform/Context";

export function* teamSaga(): SagaIterator {
    // Register the load teams action handler
    yield effects.takeLatest(TeamActionTypes.LoadTeamsRequested, loadTeams);
}

export function* loadTeams(): SagaIterator {
    const teams = (yield effects.select(getTeams)) as any;
    if (!teams) {
        yield effects.put(TeamActionsCreator.beginLoadTeams());

        try {
            const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
            const teamSource = new TeamSource(pageContext);
            const teams: ITeam[] = (yield effects.call([teamSource, teamSource.fetchTeamsForCurrentProject])) as any;
            yield effects.put(TeamActionsCreator.loadTeamsSucceeded(teams));
        } catch (error) {
            yield effects.put(TeamActionsCreator.loadTeamsFailed(error));
        }
    }
}
